const getters = {
  /**
   * ========================================================
   * ************   公共部分   ************
   * ========================================================
   */
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js